module.exports = function() {
    return function debug() {
        // empty mock of debug module for browser usage
    };
};